import React from 'react';
import { RichText } from 'prismic-reactjs';

export default function Text({ page }) {
  return <div className="additional-info-text">{RichText.render(page.items[0].single_book_description.raw)}</div>;
}
